export default __webpack_public_path__ + "ef49bf3e550a22c82dc75587754942af.webp";